const LoginFolderConfigs = {
    footerText: `© ${new Date().getFullYear().toString()} Sovos Compliance, LLC`,
    loadingPageText: "SAF-T",
};

export default LoginFolderConfigs;
